import { rebuildPVDiagram as diagramrebuildPVDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type rebuildPVDiagramProps = {};

export const rebuildPVDiagram = ({ }: rebuildPVDiagramProps) => {
    diagramrebuildPVDiagram('rebuildPVDiagramShared');
};
